import Link from "next/link";
import { Button } from "@nextui-org/button";

const buttonSize = (size) => {
  switch (size) {
    case "sm":
      return "py-2 px-4 text-sm";
    case "lg":
      return "py-3 px-6 text-xl";
    case "both":
      return "py-2 px-4 text-sm llg:py-3 llg:px-6 llg:text-xl";
    default:
      return "py-2 px-4 text-base";
  }
};

const MyButton = ({
  color = "primary",
  href,
  variant = "shadow",
  label,
  className = "",
  size,
  landscapeBlock,
  ariaLabel,
  alignment,
  target,
}) => {
  return (
    <Link
      href={href}
      prefetch={false}
      aria-label={ariaLabel}
      className={`${alignment ?? ""} ${landscapeBlock ? "llg:self-end" : ""}`}
      target={target}
    >
      <Button
        color={color}
        variant={variant}
        className={`${buttonSize(size)} ${className} ${
          landscapeBlock ? "llg:self-end" : ""
        }`}
      >
        {label}
      </Button>
    </Link>
  );
};

export default MyButton;
